export {
    getBaseName,
    sanitizeAssetName,
    webpackDevAssetsRegexp,
    webpackProdAssetsRegexp,
    calendarWRMRegexp,
} from './sanitize-asset-name';
